import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { Angulartics2Module } from 'angulartics2';
import { ItemListComponent } from './components/item-list/item-list.component';
import { ShareButtonModule } from '../share-button/share-button.module';
import { ItemThumbnailModule } from '../item-thumbnail/item-thumbnail.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatIconModule,
        RouterModule,
        ShareButtonModule,
        Angulartics2Module,
        ItemThumbnailModule
     ],
    declarations: [
        ItemListComponent
    ],
    exports: [
        ItemListComponent,
    ]
})
export class ItemListModule {}